export default "__VITE_ASSET__DGZriLo3__"